export default (string = '', maxLength = 140) => string.substring(0, maxLength);
